import { AxiosPromise } from 'axios'

import api from '@config/api'

// Weight
export function getParamsCurveWeight(): AxiosPromise {
  const url = 'v1/ParametroCurvaPeso'

  return api.get(url)
}

export function postParamsCurveWeight(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaPeso', data, {})
}

export function removeParamsCurveWeight(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaPeso/remover', data, {})
}

// Executation
export function getParamsCurveExecutation(): AxiosPromise {
  const url = 'v1/ParametroCurvaExecucao'

  return api.get(url)
}

export function postParamsCurveExecutation(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaExecucao', data, {})
}

export function removeParamsCurveExecutation(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaExecucao/remover', data, {})
}

// Depedents CD
export function getParamsCurveDepedetensCD(): AxiosPromise {
  const url = 'v1/ParametroCurvaDepedentesCD'

  return api.get(url)
}

export function postParamsCurveDepedetensCD(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaDepedentesCD', data, {})
}

export function removeParamsCurveDepedetensCD(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaDepedentesCD/remover', data, {})
}
// IncrementSupplier
export function getParamsCurveStore(
  search: any,
  page: any,
  take: any,
  obj: any
): AxiosPromise {
  const url = 'v1/ParametroCurvaNovaLoja/filtro'

  return api.post(url, obj, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: take
      })
    }
  })
}

export function postParamsCurveStore(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaNovaLoja', data, {})
}

export function removeParamsCurveStore(data: any): AxiosPromise {
  return api.post('v1/ParametroCurvaNovaLoja/remover', data, {})
}
export default {
  getParamsCurveWeight,
  postParamsCurveWeight,
  removeParamsCurveWeight,
  getParamsCurveExecutation,
  postParamsCurveExecutation,
  removeParamsCurveExecutation,
  getParamsCurveDepedetensCD,
  postParamsCurveDepedetensCD,
  removeParamsCurveDepedetensCD,
  getParamsCurveStore,
  postParamsCurveStore,
  removeParamsCurveStore
}
